export const activeIntelligenceStatuses=new Set(['pending','scanning','analyzing','synthesizing']);
export async function fetchBrandIntelligence(brandId:number){
 const response=await fetch(`/api/brands/${brandId}/intelligence`,{credentials:'include'});
 if(!response.ok)throw new Error('Could not load ad intelligence. Please try again.');
 const data=await response.json();
 if(data===null)return null;
 if(!data||typeof data!=='object'||typeof data.status!=='string'||!Array.isArray(data.ads))throw new Error('The ad intelligence response was incomplete. Please try again.');
 return data;
}
export function intelligenceViewState(data:{status:string;ads?:unknown[];totalAdsScanned?:number|null}|null|undefined,loading:boolean,error:unknown){
 if(loading&&!data)return 'loading';
 if(error&&!data)return 'error';
 if(!data)return 'absent';
 if(activeIntelligenceStatuses.has(data.status))return 'active';
 if(data.status==='failed')return 'failed';
 if(data.status==='completed'&&!data.ads?.length)return 'empty';
 return 'evidence';
}
